// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"6f272282","94":"3c94c639","120":"bc0b6618","126":"8123898b","171":"92227373","407":"7b517597","432":"83e80216","532":"f0069298","674":"22ade9ce","684":"ed4f155c","711":"7672836a","744":"8658b16c","994":"7560ccf1"}[chunkId] + ".chunk.js";
};